import React, { useState, useEffect } from "react";
import { Col, DatePicker, Pagination } from "antd";
import "../../assets/css/search-filter.css";
import dayjs from 'dayjs';
import { useSearchParams } from "react-router-dom";
import CandidateFilter from "../../components/filter/CandidateFilter";
import CandidateTable from "../../components/table/CandidateTable";
import { useDispatch, useSelector } from "react-redux";
import { listCandidate } from "../../features/candidate/candidateSlice";
import CandidateCards from "../../components/card/CandidateCard";
import { isMobile } from "../../utils/Utils";


export default function ManageCandidates() {

  const { RangePicker } = DatePicker;
  const [searchParams, setSearchParams] = useSearchParams();
  const { candidates } = useSelector((state) => state.candidate);
  const [profession, setProfession] = useState("Professions");
  const [authenticationProvider, setAuthenticationProvider] = useState("AP");
  const [source, setSource] = useState("Sources");
  const [status, setStatus] = useState("status");
  const [val, setVal] = useState("Search");
  const [campaignVal, setCampaignVal] = useState("campaigns");
  const [candidateTypeVal, setCandidateTypeVal] = useState("All Candidates");

  const dispatch = useDispatch();

  const detectMobile = isMobile();

  const fetchCandidates = () => {
    if(!searchParams.get("page")) {
      searchParams.set("page", 1);
    }
    if(!searchParams.get("limit")) {
      searchParams.set("limit", 10);
    }

    if(searchParams.get("search")){
      dispatch(listCandidate(encodeURI(searchParams.get("search")) + "?" + searchParams.toString()));
    }else{
      dispatch( listCandidate("?" +searchParams.toString()) );
    }

  };

  // handle pagination per page
  const onShowSizeChange = (current, pageSize) => {
    searchParams.set("page", current);
    searchParams.set("limit", pageSize);
    setSearchParams(searchParams);
  };

  // handle pagination page
  const handleChange = (page, pageSize) => {
    searchParams.set("page", page);
    searchParams.set("limit", pageSize);
    setSearchParams(searchParams);
    window.scrollTo(0, 0);
  };

  // For applied filters
  useEffect(() => {
    fetchCandidates();
    if(!searchParams.get("Professioncode")){
      setProfession("Professions");      
    }
    if(!searchParams.get("AuthenticationProvider")){
      setAuthenticationProvider("AP");
    }
    if(!searchParams.get("Status")){
      setStatus("status");
    }
    if(!searchParams.get("Source")){
      setSource("Sources");
    }
    if(!searchParams.get("search")){
      setVal("search");
    }
    if(!searchParams.get("Campaign")){
      setCampaignVal("Campaign");
    }
    if(!searchParams.get("PvtEmpIds")){
      setCandidateTypeVal("All Candidates");
    }
  }, [searchParams]);
  
  // handle date change
  const handleDateChange = (dates) => {
    if (!(!dates || !dates[0] || !dates[1])) {
      let startDate = dayjs(dates[0].$d).format("MM-DD-YYYY");
      let endDate = dayjs(dates[1].$d).format("MM-DD-YYYY");
      searchParams.set("StartDate", startDate);
      searchParams.set("EndDate", endDate);
      setSearchParams(searchParams);
    }
    else {
      searchParams.delete("StartDate");
      searchParams.delete("EndDate");
      setSearchParams(searchParams);
    }
  };

  return (
    <div className="ManageCandidateContainer">
      <div className="rcdFilterContainer">
        <div className="dateRangePickerContainer">
          <div className="userTypeText">Manage Candidate</div>
          {!detectMobile && <div className="dateRangePickerBox">
          <RangePicker
              suffixIcon={false}
              className="dateRangePicker"
              onChange={handleDateChange}
              value={
                [searchParams.get("StartDate") ? dayjs(searchParams.get("StartDate"), "MM-DD-YYYY") : null,
                  searchParams.get("EndDate") ? dayjs(searchParams.get("EndDate"), "MM-DD-YYYY") : null]
              }
              format="MMM D, YYYY"
            />
          </div>}
        </div>
        {!detectMobile && <div className="userTypeCount">
          Showing {candidates.length ? candidates[0].TotalCount : 0} results
        </div>}
      </div>
      <CandidateFilter 
        profession={profession} 
        setProfession={setProfession}
        status={status}
        setStatus={setStatus}
        authenticationProvider={authenticationProvider}
        setAuthenticationProvider={setAuthenticationProvider}
        source={source}
        setSource={setSource}
        val={val} 
        setVal={setVal}
        campaignVal={campaignVal}
        setCampaignVal={setCampaignVal}
        candidateTypeVal={candidateTypeVal}
        setCandidateTypeVal={setCandidateTypeVal}
      />
      {detectMobile && <Col className="SearchHeader-Show-Results-section" span={24}>
        <span className="SearchHeader-Show-Results">
          Showing {candidates.length ? candidates[0].TotalCount : 0} results
        </span>
      </Col>}
      <div className="CommonTableContainer">
      {!detectMobile ? <CandidateTable fetchCandidates={fetchCandidates} /> : <CandidateCards fetchCandidates={fetchCandidates} />}
        <br />
        <Pagination
          showSizeChanger
          defaultPageSize={searchParams.get("limit") ? searchParams.get("limit") : 10}
          defaultCurrent={searchParams.get("page") ? searchParams.get("page") : 1}
          current={searchParams.get("page") ? searchParams.get("page") : 1}
          pageSize={searchParams.get("limit") ? searchParams.get("limit") : 10}
          onChange={handleChange}
          onShowSizeChange={onShowSizeChange}          
          total={candidates.length ? candidates[0].TotalCount : 0}
        />
      </div>
    </div>
  );
}
